import { Company, TaskAssignedResource, Team } from '@dispatch/shared/types';
import { Grid, Skeleton, Stack } from '@mui/material';
import { ResourceP } from '@dispatch/web/features/tasks';

export const AssignedResourceSection = ({
  assignedResourceData,
  resourceData,
  isAssigning,
  company,
}: {
  assignedResourceData?: TaskAssignedResource | null;
  resourceData?: TaskAssignedResource | null;
  isAssigning: boolean;
  company?: Company;
}) => {
  const findResourceTeam = () => {
    return (
      company?.team?.filter(
        (t: Team) => t.integrationGUID === (resourceData as any)?.teamId
      )?.[0]?.name || ''
    );
  };

  return (
    <Grid container spacing={3} data-testid="assigned-resource">
      <Grid>
        <Stack>
          <ResourceP>Resource Name</ResourceP>
          {isAssigning ? (
            <Skeleton animation="wave" />
          ) : (
            <p
              style={{
                whiteSpace: 'nowrap',
                marginTop: 0,
                paddingTop: 0,
              }}
            >
              {`${assignedResourceData?.name || '--'}`}
            </p>
          )}
        </Stack>
      </Grid>
      <Grid size={2}>
        <Stack>
          <ResourceP>Team</ResourceP>
          {isAssigning ? (
            <Skeleton animation="wave" />
          ) : (
            findResourceTeam() || '--'
          )}
        </Stack>
      </Grid>
      <Grid size={2}>
        <ResourceP>Resource Timezone</ResourceP>
        {isAssigning ? <Skeleton animation="wave" /> : '--'}
      </Grid>
    </Grid>
  );
};
